/**
 * Oglindă frontend a registrului de platforme marketplace (backend:
 * apps/api/src/modules/reconciliation/marketplace-platforms.ts). Codul platformei
 * e și valoarea `?platform=` trimisă API-ului. Ține etichetă, rută UI și logo.
 */
export interface MarketplacePlatformMeta {
  code: string;
  label: string;
  pagePath: string;
  logoSrc?: string;
}

export const MARKETPLACE_PLATFORMS: Record<string, MarketplacePlatformMeta> = {
  emag: {
    code: 'emag',
    label: 'eMAG Marketplace',
    pagePath: '/comenzi-emag',
    logoSrc: '/payment-logos/emag.png',
  },
  fashiondays: {
    code: 'fashiondays',
    label: 'Fashion Days',
    pagePath: '/comenzi-fashion-days',
    logoSrc: '/payment-logos/fashiondays.png',
  },
  trendyol: {
    code: 'trendyol',
    label: 'Trendyol',
    pagePath: '/comenzi-trendyol',
    logoSrc: '/payment-logos/trendyol.svg',
  },
};

export function marketplaceLabel(code: string): string {
  return MARKETPLACE_PLATFORMS[code]?.label ?? code;
}

/**
 * URL de urmărire la curier după AWB, din numele curierului raportat de marketplace
 * (ex. Trendyol `cargoProviderName` = "DPD Romania"). Pattern-uri aliniate cu
 * `COURIER_CONFIG` din apps/api/.../couriers/couriers.service.ts. Curier necunoscut → null.
 */
const COURIER_TRACKING: Array<{ match: RegExp; url: (awb: string) => string }> = [
  { match: /dpd/i, url: (awb) => `https://tracking.dpd.ro/?shipmentNumber=${encodeURIComponent(awb)}` },
  { match: /sameday/i, url: (awb) => `https://sameday.ro/#awb=${encodeURIComponent(awb)}` },
  { match: /cargus/i, url: (awb) => `https://www.cargus.ro/tracking/?t=${encodeURIComponent(awb)}` },
  { match: /fan/i, url: (awb) => `https://www.fancourier.ro/awb-tracking/?awb=${encodeURIComponent(awb)}` },
  { match: /gls/i, url: (awb) => `https://gls-group.com/RO/ro/urmareste-coletul?match=${encodeURIComponent(awb)}` },
];

export function courierTrackingUrl(provider?: string | null, awb?: string | null): string | null {
  if (!provider || !awb) return null;
  const hit = COURIER_TRACKING.find((c) => c.match.test(provider));
  return hit ? hit.url(awb) : null;
}
